// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3XFbl","buttons":"Footer_buttons__1Qtxh"};